import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { UntypedFormControl, ValidationErrors, Validators } from '@angular/forms';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';


@Component({
    selector: 'create-name',
    templateUrl: './create-name.component.html',
    styleUrls: ['./create-name.component.scss']
})
export class CreateNameComponent extends BaseComponent
                                 implements OnInit {

    @Input()
    public createBtnLabel: string;

    @Input()
    public nameLabel: string;

    @Input()
    public errorLabels: Array<{ error: string, label: string }>;

    @Output()
    public nameEntered = new EventEmitter<string>();

    @Output()
    public canceled = new EventEmitter<any>();

    public panelOpen: boolean;

    public name: UntypedFormControl;

    constructor() {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();
        this.panelOpen = false;
        this.createBtnLabel = this.createBtnLabel || marker('common.btn.create');
        this.nameLabel = this.nameLabel || marker('common.label.name');

        this.name = new UntypedFormControl(
            {
                value: '',
                disabled: this.disabled
            },
            {
                updateOn: 'change',
                validators: [Validators.required],
            });
    }

    private reset(): void {
        this.panelOpen = false;
        this.name.setValue('');
    }

    // MAIN BUTTONS **************************************************************************************************

    public submit(): void {
        this.nameEntered.emit(this.name.value);
        this.reset();
    }

    public cancel(): void {
        this.reset();
        this.canceled.emit();
    }

    // EXTERNAL ERROR HANDLING

    public setNameInputError(errors: ValidationErrors): void {
        this.name.setErrors(errors);
    }

}
